<template>
  <div id="filter">
    
    <!-- 
      HOWITWORKS 
      
      Since Filter is a reference to AppData.app.pages[this.page].filtering, which is being watched by List.vue, it will immediately trigger the list to reload using the filter object.
    -->

    <v-app dark>
      <div class="search" v-if="filtering.search">
        <div class="title-value">
          Search
        </div>
        <div class="section">
          <div class="search-input">
            <div class="p-input">
              <input tabindex="-1" v-debounce="500" ref="searchInput" type="text" v-model.lazy="filtering.search.value" required="required" :placeholder="filtering.search.placeholder">
            </div>
            <div class="search-button">
              <i class="search-icon mdi mdi-24px mdi-magnify"></i>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>

      <div class="title-value">
        Basic Filters
      </div>
      <div class="section">

        <div class="filter" v-for="(filter, key) in filtering.filters" :key="key" v-if="hasPermissions(filter.permissions)">
          <div class="filter-title">{{ filter.title }}</div>
          <div class="options">

            <v-radio-group v-model="filter.value" :mandatory="false">
              <v-radio color="primary" v-for="(option, optionKey) in filter.options" @change="storeOption(option, key)" :label="option.title" :value="option.value" :key="optionKey"></v-radio>
            </v-radio-group>
            
          </div>
        </div>

      </div>
    </v-app>
  </div>
</template>

<script>

  import permissionMixin from '../mixins/permissionMixin.js'

  export default {
    mixins: [permissionMixin],
    data () {
      return {

      }
    },
    props: {
      filtering: {
        required: true,
        type: Object
      }
    },
    methods: {
      storeOption (option, key) {
        
        // Store on the route name
        var routeName = this.$route.name;
        if (routeName === 'invited') routeName = 'joined'; // to work with the hack that joined == invited

        // Preserve existing local storage on this page
        var current;
        if (localStorage.getItem(routeName)) {
          current = JSON.parse(localStorage.getItem(routeName));
        }
        else {
          current = {};
        }

        // Apply the new storage
        current[key] = option.value;
        localStorage.setItem(routeName, JSON.stringify(current));
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';
  @import '../css/vo-radio-button.scss';
  @import '../css/p-input.scss';

  #filter {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: $dark;
    overflow: hidden;
    @include scrollable;

    .search {

      border-bottom: 1px solid $white12;

      .search-input {

        width: calc(100% - 32px);
        margin: 16px auto 0;

        .p-input {
          min-height: 60px;
          width: calc(100% - 36px);
          color: #FFF;
          position: relative;
          float: left;

          input {
            background: rgba(0,0,0,0);
            border-bottom: 2px solid rgba(255,255,255,.54) !important;
            color: #FFF;
          }
        }
  
        .search-button {
          
          float: right;
          padding: 4px;
    
          .search-icon {
            color: $white54;
            cursor: pointer;
          }
        }

      } // .search-input
    } // .search


    .title-value {

      @include fontPrimary500();
      user-select: none;
      background: $black12;
      padding: 28px 16px;
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: $filterTitle;
      border-bottom: solid 1px $white12;
    }

    .filter {
      
      .filter-title {
        
        @include fontPrimary400();
        font-size: 18px;
        color: $white;
        
        margin: auto 16px;
        padding: 24px 0 12px;
        width: calc(100% - 32px);
        border-bottom: solid 1px $white12;
      }
    
      .options {

        width: calc(100% - 32px);
        margin: 8px auto;

      } // .options

    } // .filter

  } // #filter

</style>



// WEBPACK FOOTER //
// src/components/Filter.vue